import { render, staticRenderFns } from "./CCMMedicalNote.vue?vue&type=template&id=4420b8b1"
import script from "./CCMMedicalNote.vue?vue&type=script&lang=js"
export * from "./CCMMedicalNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports